import type { Condition, ControlRules, Severity } from '@repo/api-gw-sdk';

import type { Step } from '@/components/wizard/Step';

import { ControlConditionEditor } from './ControlConditionEditor';
import { ControlNameSelection } from './ControlNameSelection';

export interface ControlEditState {
  id: string;
  name: string;
  condition?: Condition;
  rules: ControlRules;
  severity: Severity;
}

export const ControlCreationFlow: Step<ControlEditState> = {
  id: 'name_selection',
  Component: ControlNameSelection,
  nonReturnable: true,
  next: [
    {
      id: 'condition',
      Component: ControlConditionEditor,
    },
  ],
};
